import { createNS } from "@ontologies/core";
/** Function to create arbitrary terms within the 'Linked-Delta Ontology' ontology */
export const ns = createNS("http://purl.org/linked-delta/");
/* Classes */
export const DeltaGraph = /*#__PURE__*/ ns("DeltaGraph");
/* Properties */
/* Other terms */
/** Adds the statement to the store, without duplication. */
export const add = /*#__PURE__*/ ns("add");
/** Removes the entire subject from the store. */
export const purge = /*#__PURE__*/ ns("purge");
/** Removes all (subject,predicate,) matches from the store. */
export const remove = /*#__PURE__*/ ns("remove");
/** Replaces the (subject, predicate,) with the one(s) in this delta. */
export const replace = /*#__PURE__*/ ns("replace");
/** Removes all (subject,predicate,object) matches from the store. */
export const slice = /*#__PURE__*/ ns("slice");
/** Removes all statements of (subject,,) from the store and replaces them with those in the delta. */
export const supplant = /*#__PURE__*/ ns("supplant");
